import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {cmrServicesKeyToArrayOfCmrServices} from './relationships';
import CmrDomainStore from "./CmrDomainStore";
// let cmrServices = {
//   0: {

//   },
//   1: {

//   },
//   2: {

//   }
// };


let cmrServices = {};

const defaults = {

};

const CmrServiceStore = createStore({
  storeEventBaseKey: "cmr_services",
  normalizr: cmrServicesKeyToArrayOfCmrServices,
  normalizrKey: "cmrServices",
  getData(){
    return cmrServices;
  },
  getDefaults(){
    return defaults;
  },
  removeServicesByIds(ids){
    this.removeObjectsByIdsAndEmit(cmrServices, ids);
  },
  createOrUpdateServicesForAsnDetailIds(detailIds=[], data){
    data.csv_entity_type = "asn_detail";
    const detailIdAndTypeToServices = this.detailIdAndTypeToServices();
    _(detailIds).map((detailId)=>{
      const specificData = _.extend({}, data, {csv_entity_id: detailId});
      let service = _(detailIdAndTypeToServices[`${detailId}_asn_detail`]).findWhere({cdm_id: data.cdm_id});
      if(!service){
        this.createNewService(specificData);
      }
      else{
        this.updateObjectAndEmit(service.id, specificData);
      }
    })
  },
  createOrUpdateServicesForAsnId(asnId, data){
    const specificData = _.extend({}, data, {csv_entity_type: "asn", csv_entity_id: asnId});
    let service = _(this.getServicesViaAsnId(asnId)).findWhere({cdm_id: specificData.cdm_id});
    if(!service){
      this.createNewService(specificData);
    }
    else{
      this.updateObjectAndEmit(service.id, specificData);
    }
  },
  detailIdAndTypeToServices(services){
    if(!services){
      services = this.dataAsArray();
    }
    return _(services).groupBy((service)=>{return `${service.csv_entity_id}_${service.csv_entity_type}`;});
  },
  getServicesViaAsnId(asnId){
    return _(this.dataAsArray()).where({csv_entity_id: asnId, csv_entity_type: "asn"});
  },
  getServicesViaAsnDetailIds(detailIds=[]){
    const detailIdAndTypeToServices = this.detailIdAndTypeToServices();
    return _.chain(detailIds).map((detailId)=>{
      return detailIdAndTypeToServices[`${detailId}_asn_detail`];
    })
    .filter((service)=>{return service;})
    .flatten()
    .value();
  },
  getServicesViaAsnDetailId(detailId){
    return _(this.dataAsArray()).where({csv_entity_id: detailId, csv_entity_type: "asn_detail"});
  },

  organizeByEntity(services=[]){
    return _(this.detailIdAndTypeToServices(services)).values();
  },
  createNewService(data){
    data = _.extend({id: _.uuid()}, defaults, data);
    return this.addService(data);
  },
  addService(data){
    return this.addObjectsAndEmit(cmrServices, data);
  }
});

window.CmrServiceStore = CmrServiceStore;
export default CmrServiceStore;


// WEBPACK FOOTER //
// ./src/stores/CmrServiceStore.js